<template>
    <v-dialog v-model="modal" :scrim="false" width="500">
        <v-card>
            <v-icon class="v-card-close" @click="modal = false">mdi-close</v-icon>
            <v-card-title class="text-h6 font-weight-light">
                {{ label }}
            </v-card-title>
            <v-card-text v-if="type === 'CONFIRM'">
                {{ $t('enter_reference') }}
                <v-text-field v-if="type === 'CONFIRM'" v-model="refNumber" single-line />
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn
                    v-if="type === 'CONFIRM' || 'CANCEL_CONFIRM'"
                    :loading="isLoading"
                    :disabled="isLoading"
                    color="primary"
                    size="small"
                    @click="reservationAction"
                >
                    {{ $t('supplier.confirm') }}
                </v-btn>
                <v-btn
                    v-if="type === 'REJECT'"
                    :loading="isLoading"
                    :disabled="isLoading"
                    color="error"
                    variant="flat"
                    size="small"
                    @click="reservationAction"
                >
                    {{ $t('supplier.reject') }}
                </v-btn>
                <v-btn color="grey" size="small" class="text-white" @click="modal = false">
                    {{ $t('close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {CHANGE_LOCALE_EVENT, EventBus, SHOW_RESERVATION_STATUS_MODAL} from '@/utils/event-bus'

    @Component
    export class ReservationsStatusModal extends Vue {
        modal = false
        type = ''
        processId = ''
        refNumber = ''
        orderId = null
        isLoading = false

        mounted() {
            EventBus.$on(SHOW_RESERVATION_STATUS_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_RESERVATION_STATUS_MODAL, this.showModal)
        }

        async showModal({type, processId}, orderId) {
            this.type = type
            this.processId = processId
            this.orderId = orderId
            this.modal = true
        }

        async reservationAction() {
            this.isLoading = true
            try {
                const data = {
                    processId: this.processId,
                    status: this.type === 'CANCEL_CONFIRM' ? 'CONFIRM' : this.type,
                }
                if (this.type === 'CONFIRM') data.refNumber = this.refNumber

                await this.$api.modifyStatus.put(data)

                if (this.$conf.public.reservationReport && this.processId && this.isMarkAsNotSentToSupplier) {
                    await this.markAsNotSentToSupplier()
                }
                EventBus.$emit(CHANGE_LOCALE_EVENT)
            } catch (error) {
                this.$toast.error(this.$t('error_message.something_went_wrong'))
            }
            this.isLoading = false
        }

        async markAsNotSentToSupplier() {
            await this.$api.orders.put(this.orderId, {
                servicesInfo: [
                    {
                        processId: this.processId,
                        serviceSentToSupplier: false,
                    },
                ],
            })
        }

        get isMarkAsNotSentToSupplier() {
            return true
        }

        get label() {
            switch (this.type) {
                case 'CONFIRM':
                    return this.$t('do_you_confirm_the_booking')
                case 'CANCEL_CONFIRM':
                    return this.$t('do_you_confirm_cancel_the_booking')
                default:
                    return this.$t('do_you_reject_the_booking')
            }
        }
    }

    export default ReservationsStatusModal
</script>
